module.exports = __webpack_public_path__ + "static/media/MA.8d442890.svg";